'use strict';

var _ = require('lodash');
var SearchCriteriaRsqlQueryService = function SearchCriteriaRsqlQueryService(RsqlQuery, rsqlQueryService, rsqlQueryGroupStrategies, optWeekRuleOperatorService, $cacheFactory) {
  var serializedQueryCache = $cacheFactory('SearchCriteriaRsqlQueryCache');
  var OPERATOR_AND = 'and';
  var OPERATOR_OR = 'or';
  function getRsqlQueryGroupStrategy(strategy) {
    var availableStrategies = rsqlQueryGroupStrategies;
    return availableStrategies[strategy] || availableStrategies["default"];
  }
  function getFieldMetaData(field) {
    var metaData = {
      strategy: 'default',
      field: field
    };
    if (/^custom\:/.test(field)) {
      var parts = field.split(/:/);
      metaData.strategy = parts[1];
      metaData.field = parts[2] || parts[1];
    }
    return metaData;
  }
  function createRsqlQueryGroup(field, rules) {
    var fieldMetaData = getFieldMetaData(field);
    var strategy = getRsqlQueryGroupStrategy(fieldMetaData.strategy);
    return strategy(fieldMetaData.field, rules);
  }
  function getInclusionTypeRules(rules) {
    return _.chain(rules).filter(function (rule) {
      if (!rsqlQueryService.isValidOperator(rule.operator)) {
        throw new Error('Invalid operator type ' + rule.operator);
      }
      return rsqlQueryService.isInclusionTypeOperator(rule.operator);
    }).groupBy(function (rule) {
      return rule.field;
    }).value();
  }
  function getExclusionTypeRules(rules) {
    return _.chain(rules).filter(function (rule) {
      if (!rsqlQueryService.isValidOperator(rule.operator)) {
        throw new Error('Invalid operator type ' + rule.operator);
      }
      return rsqlQueryService.isExclusionTypeOperator(rule.operator);
    }).groupBy(function (rule) {
      return rule.field;
    }).value();
  }
  function getRuleGroups(rules) {
    return _.chain(rules).uniqBy(function (rule) {
      return rule.hashCode();
    }).groupBy(function (rule) {
      return rule.metaCategory;
    }).transform(function (result, rules, metaCategory) {
      var orRules = getInclusionTypeRules(rules);
      var andRules = getExclusionTypeRules(rules);
      result[metaCategory] = {
        orRules: orRules,
        andRules: andRules
      };
      return result;
    }, {}).value();
  }
  function buildRulesHash(rules) {
    return _.map(rules, function (element) {
      return element.hashCode();
    }).join('-');
  }
  function addRsqlQueryGroup(field, rules, builder, operatorType) {
    var queryGroup = createRsqlQueryGroup(field, rules);
    if (queryGroup.length === 0) {
      return builder;
    }
    if (operatorType === OPERATOR_AND) {
      builder = builder.and();
      builder = builder.andGroup.apply(builder, queryGroup);
    } else if (operatorType === OPERATOR_OR) {
      builder = builder.or();
      builder = builder.orGroup.apply(builder, queryGroup);
    }
    return builder;
  }
  function createQueryBuilder(rules) {
    var rulesGroups;
    var queryBuilder;
    rulesGroups = getRuleGroups(rules);
    queryBuilder = _.reduce(rulesGroups, function (queryBuilder, group) {
      var groupQuery = new RsqlQuery();
      var orRulesLength = Object.keys(group.orRules).length;
      var andRulesLength = Object.keys(group.andRules).length;
      if (orRulesLength >= 1) {
        groupQuery = _.reduce(group.orRules, function (builder, rules, field) {
          return addRsqlQueryGroup(field, rules, builder, OPERATOR_OR);
        }, groupQuery);
      }
      if (andRulesLength >= 1) {
        groupQuery = _.reduce(group.andRules, function (builder, rules, field) {
          return addRsqlQueryGroup(field, rules, builder, OPERATOR_AND);
        }, groupQuery);
      }
      if (groupQuery.queue === undefined) {
        return queryBuilder;
      }
      var and = queryBuilder.and();
      return orRulesLength + andRulesLength >= 1 ? and.andGroup.apply(and, [groupQuery]) : and;
    }, new RsqlQuery().and());
    return queryBuilder;
  }
  function getRsqlQueryFromSearchCriteriaRules(rules) {
    //each widget on the page when ask for data, try to serialize search query to string to use it as key for cache.
    //serialization of 2 rules (1 date and 1 market with 6 markets) takes 10-15ml. In case 7000 markets it takes 400-500ml.
    //On market page 7 components ask for data, 15 * 7 = 100ms (best case). 500 * 7 = 3500ms (worse case).
    //calculating hash for rules takes 1-2ms. In this case query will be calculated only once for first element.
    //all other just check hash in service cache;
    //moreover, when user select brush, each component try to retrieve data. So, before providing hash
    // it used the same building filter string, and took the same time.
    rules = optWeekRuleOperatorService.transformRule(rules);
    var rulesCacheKey = buildRulesHash(rules);
    var cachedSerializedQuery = serializedQueryCache.get(rulesCacheKey);
    if (cachedSerializedQuery !== undefined) {
      return cachedSerializedQuery;
    }
    var queryBuilder = createQueryBuilder(rules);
    var serializedQuery = queryBuilder !== undefined ? queryBuilder.query() : '';
    serializedQueryCache.put(rulesCacheKey, serializedQuery);
    return serializedQuery;
  }
  function clearSerializedQueryCache() {
    serializedQueryCache.removeAll();
  }
  function appendScenarioNameToMarketProductRule(rules, scenarioName) {
    var rulesArr = rules.split(',');
    var length = rulesArr.length;
    rules = '';
    _.each(rulesArr, function (rule, i) {
      if (i + 1 != length) {
        rules = rules.concat(rule.slice(0, -1).concat(';scenarioName==\'' + scenarioName + '\'),'));
      } else {
        rules = rules.concat(rule.slice(0, -2).concat(';scenarioName==\'' + scenarioName + '\'),'));
      }
    });
    return rules.slice(0, -1).concat(')');
  }
  return {
    getRsqlQueryFromSearchCriteriaRules: getRsqlQueryFromSearchCriteriaRules,
    clearSerializedQueryCache: clearSerializedQueryCache,
    appendScenarioNameToMarketProductRule: appendScenarioNameToMarketProductRule
  };
};
SearchCriteriaRsqlQueryService.$inject = ['RsqlQueryFactory', 'RsqlQueryService', 'RsqlQueryGroupStrategies', 'OptWeekRuleOperatorService', '$cacheFactory'];
module.exports = SearchCriteriaRsqlQueryService;